// serie/series

$(document).ready(function() {
    initModalEvents();
    initSeriesBanner();
});
